import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=297f14e4"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=297f14e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports